import { render, staticRenderFns } from "./FCPointSettingsDialog.vue?vue&type=template&id=01c50911&scoped=true"
import script from "./FCPointSettingsDialog.vue?vue&type=script&lang=js"
export * from "./FCPointSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c50911",
  null
  
)

export default component.exports